import type { TreeEditRequest } from "../api/types";

export default function PendingEditBanner({ edits }: { edits: TreeEditRequest[] }) {
    const open = edits.filter((e) => e.state === "mr_open");
    if (open.length === 0) return null;
    return (
        <div className="banner yellow">
            {open.map((e) => (
                <div key={e.id} className="banner-row">
                    <strong>Pending tree edit:</strong>
                    <span>{e.summary}</span>
                    <span className="muted">
                        envs: {e.affectedEnvs.join(", ")} · by {e.requestedBy}
                    </span>
                    {e.mr ? (
                        <a href={e.mr.webUrl} target="_blank" rel="noopener noreferrer">
                            MR !{e.mr.iid}
                        </a>
                    ) : null}
                </div>
            ))}
        </div>
    );
}
